import React from 'react';
import { useTranslate } from 'react-redux-multilingual'
import { Accordion } from "react-bootstrap";
import EachNotification from './EachNotification'

const ShipmentNotifConf = (props) =>{
    const t = useTranslate();

    if(props.moduleAdmin.params.shipment.active){
        return (
            <Accordion className='mb-2'>
                <Accordion.Item eventKey='shipment'>
                    <Accordion.Header>
                        <span style={{color:props.notificationsType.shipment.bg, fontWeight:'bold',fontSize:'0.9rem'}}>
                            {t('shipment')}&nbsp;
                            <i style={{color:props.notificationsType.shipment.bg}} className={`${props.notificationsType.shipment.icon} header-icon fs-5`}></i>
                        </span>
                    </Accordion.Header>
                    <Accordion.Body>
                        <>
                             <EachNotification  allUsers={props.allUsers} sectionId={props.sectionId} notifState={props.notifState} setNotifState={props.setNotifState} typeNotif="newShipmentToPick" bgcolor="#ffffc3" disabled={props.disabled} setDisabled={props.setDisabled}/>
                        </>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
        )
    }else{
        return(<></>)
    }
};

export default ShipmentNotifConf;